import { Exchange } from './index'
let stopDOM = ['BR', 'TIME', 'IMG', 'CANVAS', 'SCRIPT']
let stopClass = 'un-tran'
let oned = 'oned'
export default function translateBody (obj, currentEncoding) {
    let objs = (obj || document.body).childNodes
    for (let i = 0; i < objs.length; i++) {
      if (objs[i].nodeType === 3 && /[\u4e00-\u9fa5]/g.test(objs[i].textContent)) {
        objs[i].textContent = Exchange(objs[i].textContent, currentEncoding)
      } else if (objs[i].nodeType === 1 && !stopDOM.includes(objs[i].tagName) && !objs[i].classList.contains(stopClass)) {
        if (objs[i].classList.contains(oned)) {
           if (!currentEncoding) translateBody(objs[i], false)
        } else {
          translateBody(objs[i], currentEncoding)
        }
      }
    }
  }
